import React, { Component } from 'react';
// material
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Dialog, DialogContent } from '@material-ui/core';
// app
import { Message, MessageTypes } from '../../../entities/site';
// components
import AuthHeader from '../components/AuthHeader';
import AuthMessage from '../components/AuthMessage';

const useStyles = makeStyles(theme => ({
  container: {
    // minWidth: 450,
    padding: '15px 25px 25px 25px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      minWidth: 450,
    },
  },
}));

interface AuthContainerProps {
  title: string;
  open: boolean;
  message?: Message;
  onClose(data?: any): void;
}

const AuthContainer: React.FC<AuthContainerProps> = (props) => {

  const classes = useStyles({});
  const message = props.message || { message: '', messageType: MessageTypes.notification };
  return (
    <Dialog open={props.open} onClose={() => props.onClose()}>
      <AuthHeader title={props.title} onClose={() => props.onClose()} />
      { message.message !== '' && (
        <AuthMessage message={message} />
      )}
      <DialogContent className={classes.container}>
        {props.children}
      </DialogContent>
    </Dialog>
  )

}
export default AuthContainer;


// WEBPACK FOOTER //
// ./src/pages/auth/containers/Auth.tsx